import Icon from '@common/assets';
import { VersionType } from '@domain/constant/acca/VersionType';
import { AnalysisType } from '@domain/constant/analysisType';
import Colors from '@domain/constant/colors';

import classnames from 'classnames/bind';
import styles from './resultTab.module.scss';
const cx = classnames.bind(styles);

export type ResultMenuType = 'APPLY' | 'COMPETENCY' | 'DEEP';

interface ResultTabProps {
  resultState: AnalysisType | null;
  resultMenu: ResultMenuType;
  setResultMenu: (resultMenu: ResultMenuType) => void;
  isCompetency?: boolean;
  version?: VersionType | null;
}

const ResultTab = ({ resultState, resultMenu, setResultMenu, isCompetency = true, version }: ResultTabProps) => {
  const isOn = (menu: ResultMenuType) => menu === resultMenu;
  const isDisabled = resultState !== 'COMPLETE';
  const isV3Result = version === 'V3';

  const ResultTabEl = () => {
    return (
      <>
        <button
          className={cx('btn', 'apply', { on: isOn('APPLY') })}
          onClick={() => setResultMenu('APPLY')}
          type="button"
        >
          <Icon
            name="alertLight"
            width={32}
            height={32}
            fill={isOn('APPLY') ? Colors.C_WHITE : Colors.C_COOL_GRAY_60}
          />
          응시 분석결과
        </button>

        {isCompetency && (
          <button
            className={cx('btn', 'competency', { on: isOn('COMPETENCY') })}
            onClick={() => setResultMenu('COMPETENCY')}
            type="button"
            disabled={isDisabled}
          >
            <Icon
              name="contentsLight"
              width={32}
              height={32}
              fill={isOn('COMPETENCY') ? Colors.C_WHITE : Colors.C_COOL_GRAY_60}
            />
            역량 분석결과
          </button>
        )}
      </>
    );
  };

  const V3ResultTabEl = () => {
    return (
      <>
        <button
          className={cx('btn', 'apply', { on: isOn('APPLY') })}
          onClick={() => setResultMenu('APPLY')}
          type="button"
        >
          <Icon
            name="alertLight"
            width={32}
            height={32}
            fill={isOn('APPLY') ? Colors.C_WHITE : Colors.C_COOL_GRAY_60}
          />
          응시 점검 결과
        </button>

        <button
          className={cx('btn', 'competency', { on: isOn('COMPETENCY') })}
          onClick={() => setResultMenu('COMPETENCY')}
          type="button"
          disabled={isDisabled}
        >
          <Icon
            name="contentsLight"
            width={32}
            height={32}
            fill={isOn('COMPETENCY') ? Colors.C_WHITE : Colors.C_COOL_GRAY_60}
          />
          기본 분석 결과
        </button>
        <button
          className={cx('btn', 'deep', { on: isOn('DEEP') })}
          onClick={() => setResultMenu('DEEP')}
          type="button"
          disabled={isDisabled}
        >
          <Icon name="chartLight" width={32} height={32} fill={isOn('DEEP') ? Colors.C_WHITE : Colors.C_COOL_GRAY_60} />
          심층 분석 결과
        </button>
      </>
    );
  };

  return <div className={cx('btnArea')}>{!isV3Result ? <ResultTabEl /> : <V3ResultTabEl />}</div>;
};

export default ResultTab;
